import axios from "axios";
import api from "./axiosConfig";
import type { RegisterDiyResponse } from "../types";

interface ApiEnvelope<T> {
  success: boolean;
  data?: T;
  message?: string | null;
  errors?: string[] | null;
}

function unwrap<T>(payload: ApiEnvelope<T>): T {
  if (!payload.success || payload.data === undefined) {
    const msg = payload.message || "Request failed";
    const err = new Error(msg) as Error & { apiErrors?: string[] };
    err.apiErrors = payload.errors ?? undefined;
    throw err;
  }
  return payload.data;
}

function rethrowWithApiMessage(error: unknown): never {
  if (axios.isAxiosError(error)) {
    const body = error.response?.data as ApiEnvelope<unknown> | undefined;
    if (body?.message) {
      const err = new Error(body.message) as Error & { apiErrors?: string[] };
      err.apiErrors = body.errors ?? undefined;
      throw err;
    }
  }
  throw error instanceof Error ? error : new Error("Request failed");
}

export interface RegisterDiyPayload {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
}

export const diyApi = {
  registerDiy: async (payload: RegisterDiyPayload): Promise<RegisterDiyResponse> => {
    try {
      const response = await api.post<ApiEnvelope<RegisterDiyResponse>>("/auth/register-diy", payload);
      return unwrap(response.data);
    } catch (e) {
      rethrowWithApiMessage(e);
    }
  },
};
